<!-- Loading State -->
@if (isLoading) {
  <div class="product-grid">
    @for (item of [1,2,3,4,5,6,7,8]; track item) {
      <div class="product-skeleton card">
        <div class="skeleton skeleton-image"></div>
        <div class="card-body">
          <div class="skeleton skeleton-title"></div>
          <div class="skeleton skeleton-text"></div>
          <div class="skeleton skeleton-price"></div>
        </div>
      </div>
    }
  </div>
}

<!-- Empty State -->
@if (!isLoading && products.length === 0) {
  <div class="empty-state">
    <div class="empty-icon">📦</div>
    <h3 class="empty-title">Nenhum produto encontrado</h3>
    <p class="empty-message">
      Tente ajustar os filtros ou buscar por outros termos.
    </p>
  </div>
}

<!-- Product Grid -->
@if (!isLoading && products.length > 0) {
  <div class="product-grid fade-in">
    @for (product of paginatedProducts; track product.id) {
      <app-product-card [product]="product"></app-product-card>
    }
  </div>

  <!-- Pagination -->
  @if (totalPages > 1) {
    <nav class="pagination" aria-label="Navegação de páginas">
      <button 
        class="pagination-btn pagination-prev"
        (click)="previousPage()"
        [disabled]="currentPage === 1"
        aria-label="Página anterior"
      >
        ← Anterior
      </button>

      <div class="pagination-numbers">
        @for (page of pageNumbers; track page) {
          @if (page === -1) {
            <span class="pagination-ellipsis">...</span>
          } @else {
            <button
              class="pagination-number"
              [class.active]="page === currentPage"
              (click)="goToPage(page)"
              [attr.aria-label]="'Página ' + page"
              [attr.aria-current]="page === currentPage ? 'page' : null"
            >
              {{ page }}
            </button>
          }
        }
      </div>

      <button 
        class="pagination-btn pagination-next"
        (click)="nextPage()"
        [disabled]="currentPage === totalPages"
        aria-label="Próxima página"
      >
        Próxima →
      </button>
    </nav>
  }
}

